import React from "react";
import styles from "../../styles/pages/games/GameCard.module.scss";

export default function GameCard({ title, tag, desc, onPlay }) {
  return (
    <article className={styles.card}>
      <div className={styles.badge}>{tag}</div>
      <h3 className={styles.title}>{title}</h3>
      <p className={styles.desc}>{desc}</p>
      <button className={styles.btn} onClick={onPlay} aria-label={`Play ${title}`}>
        ▶ Play
      </button>
    </article>
  );
}
